/** Pomoćne funkcije za sredstva za zaštitu bilja iz šifarnika (primjene po kulturi iz Jedinstvenog spiska FFS). */

export interface Primjena {
  kultura?: string; kulture?: string[]; organizmi?: string; doza?: string | null; doza_min?: number | null; doza_max?: number | null;
  jedinica?: string | null; karenca_dana?: number | null; karenca_tekst?: string | null; max_tretmana?: number | string | null;
}
type Attrs = Record<string, unknown>;

const SOLID = ["WG", "WP", "SG", "WDG", "DF", "GR", "SP", "WS"];

export const preparatUnit = (a: Attrs) =>
  (SOLID.some((x) => String(a.formulacija ?? "").toUpperCase().startsWith(x)) ? "kg/ha" : "l/ha");

export const kultureOf = (a: Attrs) => (Array.isArray(a.kulture) ? (a.kulture as string[]) : []);

export function primjenaFor(a: Attrs, species: string[]): Primjena | undefined {
  const list = (Array.isArray(a.primjene) ? a.primjene : []) as Primjena[];
  for (const sp of species) {
    const p = list.find((x) => (x.kulture ?? []).includes(sp));
    if (p) return p;
  }
  return undefined;
}

/** Registrovano za neku od vrsta: true/false, ili null ako šifarnik nema podatak o kulturama. */
export function registeredFor(a: Attrs, species: string[]): boolean | null {
  const k = kultureOf(a);
  if (!k.length) return null;
  return species.some((s) => k.includes(s));
}

/** Doza preparata po ha iz etikete (najveća): koncentracija % × voda / 100 ili l/kg po ha. */
export function dosePerHa(p: Primjena | undefined, a: Attrs, water = 1000): { dose: number | ""; unit: string } {
  const unit = preparatUnit(a);
  if (!p || p.doza_max == null) return { dose: "", unit };
  if (p.jedinica === "%") return { dose: Math.round(((p.doza_max * water) / 100) * 1000) / 1000, unit };
  if (p.jedinica === "g/ha") return { dose: p.doza_max / 1000, unit: "kg/ha" };
  if (p.jedinica === "l/ha" || p.jedinica === "kg/ha") return { dose: p.doza_max, unit: p.jedinica };
  return { dose: "", unit };
}

export const expired = (a: Attrs, on = new Date()) =>
  !!a.vazi_do && String(a.vazi_do).slice(0, 10) < on.toISOString().slice(0, 10);
